import React from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { formatarData } from './InformacoesTab';

const ModalResponder = ({
    show,
    onHide,
    pergunta,
    formResposta,
    setFormResposta,
    salvandoResposta,
    onSalvar
}) => {
    if (!pergunta) return null;

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Responder</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3 pb-3 border-bottom">
                    <small className="text-muted">
                        {pergunta.nome_usuario_criacao} - {formatarData(pergunta.data)}
                    </small>
                    <h5 className="mt-2">{pergunta.titulo}</h5>
                    <div className="mb-2">
                        {pergunta.assunto && (
                            <span className="mr-3"><strong>Assunto:</strong> {pergunta.assunto}</span>
                        )}
                        {pergunta.empreendimento && (
                            <span><strong>Empreendimento:</strong> {pergunta.empreendimento}</span>
                        )}
                    </div>
                    {pergunta.descricao && (
                        <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{pergunta.descricao}</p>
                    )}
                </div>

                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Link</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="https://..."
                            value={formResposta.link}
                            onChange={(e) => setFormResposta({ ...formResposta, link: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Observação</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={5}
                            placeholder="Digite a resposta..."
                            value={formResposta.observacao}
                            onChange={(e) => setFormResposta({ ...formResposta, observacao: e.target.value })}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-danger" onClick={onHide}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={onSalvar} disabled={salvandoResposta}>
                    {salvandoResposta ? (
                        <>
                            <Spinner as="span" animation="border" size="sm" className="mr-2" />
                            Salvando...
                        </>
                    ) : (
                        'Salvar'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalResponder;
